module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel box-collapse border-color-skin",
    attrs: {
      "id": "hres80x-history-heal-others"
    }
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed  tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#historyHealOthers"
    }
  }, [_c('h3', {
    staticClass: "box-title color-skin"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(" " + _vm._s(_vm.labels['HRES80XP4']['10']) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "historyHealOthers"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive panel-detail-filter"
  }, [_c('div', {
    staticClass: "hisheal-header"
  }, [_vm._v(_vm._s(_vm.labels['HRES80XP4']['20']))]), _vm._v(" "), _c('textarea', {
    staticClass: "hisheal-others",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": _vm.dataHisHeal.desnote
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2a15c5f1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres80x/historyHealOthers.vue
// module id = 3645
// module chunks = 1